export const SIGNUP_URL = "/auth/signup";
export const SIGNIN_URL = "/auth/signin";
export const FORGOT_PASSWORD_URL = "/auth/forgot_password";
export const RESET_PASSWORD_URL = "/auth/reset_password";
export const REQUEST_DEMO = "request_demo";
export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || "https://www.yawakit.com/";
